import React from "react";
import { useTranslation } from "react-i18next";

//helpers
import { hasRoleLocalization } from "../../../../../constants/roleLocalizationConfig";

//components
import TooltipText from "../TooltipText";

interface IRoleProps {
  value: string;
}

const Role = ({ value }: IRoleProps) => {
  const { t } = useTranslation();

  return (
    <>
      {value ? <TooltipText value={hasRoleLocalization() ? t(`common.roles.${value}`) : value} width={160} maxWidth={160}/> : '—'}
    </>
  );
};

export default Role;
